export const FETCH_USER_OWN_DETAIL_REQUEST = 'FETCH_USER_OWN_DETAIL_REQUEST'
export const FETCH_USER_OWN_DETAIL_SUCCESS = 'FETCH_USER_OWN_DETAIL_SUCCESS'
export const FETCH_USER_OWN_DETAIL_FAILED = 'FETCH_USER_OWN_DETAIL_FAILED'
export const FETCH_USER_OWN_SET_MOBILE_VERIFIED = 'FETCH_USER_OWN_SET_MOBILE_VERIFIED'
export const FETCH_USER_OWN_CLEAR = 'FETCH_USER_OWN_CLEAR'